const initialState = {
  settled: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_TAGS":
      return {
        ...action.payload,
        settled: true
      };

    case "FETCH_TAGS_NEXT_PAGE": {
      return {
        ...action.payload,
        results: [...state.results, ...action.payload.results],
        settled: true
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/tagReducer.js